import { render, staticRenderFns } from "./ResultsWrapper.vue?vue&type=template&id=293e8cf5&scoped=true&"
import script from "./ResultsWrapper.js?vue&type=script&lang=js&"
export * from "./ResultsWrapper.js?vue&type=script&lang=js&"
import style0 from "./ResultsWrapper.scss?vue&type=style&index=0&id=293e8cf5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293e8cf5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CircleLoader: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/CircleLoader.vue').default,WordListInterlinkDirector: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/WordListInterlinkDirector/WordListInterlinkDirector.vue').default})
